interface Props {
  label: string;
  onRemove?: () => void;
}

export function TagBadge({ label, onRemove }: Props): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1 bg-slate-800 text-slate-200 px-2 py-0.5 rounded text-[11px]">
      {label}
      {onRemove !== undefined && (
        <button
          type="button"
          onClick={onRemove}
          className="text-slate-500 hover:text-red-400"
          aria-label="Supprimer ce tag"
        >
          ×
        </button>
      )}
    </span>
  );
}
